var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{attrs:{"layout":_vm.pageLayout},on:{"update:layout":function($event){_vm.pageLayout=$event}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }